<template>
  <span>
    <span v-if="showSuccess">
      <HSuccess />
      <h2 class="text-center mw-300 mx-auto mb-10 green--text">
        Pagamento realizado com sucesso!
      </h2>
    </span>
    <span v-else>
      <p> {{ description }} </p>
      <img :src="`data:image/jpeg;base64,${pixQRCode}`" class="d-block mx-auto" alt="PIX QR CODE" height="auto" width="200" />
      <v-divider class="mt-2 mb-8" />
      <v-textarea :value="pixStringCode" row="3" outlined readonly small />
      <div class="d-flex justify-center">
        <v-chip>
          <v-progress-circular :size="10" :width="1" class="mr-2" indeterminate />
          {{ $t(`recharge.status.${status}`) }}
        </v-chip>
      </div>
    </span>
  </span>
</template>

<script>
import { checkCharge } from '../checkoutService'

import HSuccess from '@/components/app/HSuccess'

export default {
  name: 'CheckoutPaymentPixQRCode',

  components: {
    HSuccess,
  },

  props: {
    pixQRCode: {
      type: String,
      required: true,
    },

    pixStringCode: {
      type: String,
      required: true,
    },

    installmentId: {
      type: String,
      required: true,
    },
  },

  watch: {
    installmentId: {
      immediate: true,
      handler() {
        this.checkPixPayment()
      },
    },
  },

  methods: {
    startRefreshInterval() {
      this.stopRefreshInterval()
      this._interval = setInterval(() => {
        this.checkPixPayment()
      }, 5000)
    },

    stopRefreshInterval() {
      if (this._interval) {
        clearInterval(this._interval)
        this._interval = null
      }
    },

    async checkPixPayment() {
      try {
        const response = await checkCharge(this.installmentId)
        const data = response.data
        const status = data.installments[0].status

        this.status = status

        if (status === 'RECEIVED' || status === 'CONFIRMED') {
          this.stopRefreshInterval()
          this.showSuccess = true
        }
      } catch (error) {
        console.error('Payment error:', error)
        this.$store.dispatch('showErrorMessage', 'Ocorreu um erro ao processar o pagamento.')
      }
    },
  },

  created() {
    this.startRefreshInterval();
  },

  beforeDestroy() {
    this.stopRefreshInterval();
  },

  data() {
    return {
      status: 'PENDING',
      description: this.$t('recharge.pix.description'),
      showSuccess: false,
      _interval: null,
    }
  },
}
</script>
